import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { fetchProjectsLeads } from 'apollo/projects.query';

import ViewOptions, {
  ViewOptionsHeading,
  ViewOptionsCheckbox,
  ViewOptionsOption,
  ViewOptionsSelect,
} from 'components/ViewOptions';

import './styles.scss';

const VisibleItem = ({ name, label, onChange, options }) => {
  let option = '';
  if (options !== undefined) {
    option = options[name];
  }

  const inputProps = {
    onChange,
    checked: option,
  };

  return (
    <ViewOptionsCheckbox id={name}
      inputProps={inputProps}
    >
      {label}
    </ViewOptionsCheckbox>
  );
};

const OptionsItem = ({
  label,
  id,
  handleChange,
  name,
  options,
  onBeforeInput = null,
}) => {
  let optionsId = '';
  if (options !== undefined) {
    optionsId = options[name];
  }

  const inputProps = {
    name,
    value: id,
    onChange: handleChange,
    onBeforeInput,
    checked: optionsId === id,
  };

  return (
    <ViewOptionsOption id={id}
      inputProps={inputProps}
    >
      {label}
    </ViewOptionsOption>
  );
};

const ProjectsViewOptions = ({
  options,
  handleChangeOptions,
  handleChangeCheckbox,
  afterDismissViewOptions,
  viewingArchive = false,
}) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const [weddingsLeads, setLeads] = useState([]);

  const [showAssignmentFilter, setShowAssignmentFilter] = useState(
    options.filter === 'lead-name',
  );

  const setLead = (e) => {
    handleChangeOptions({
      target: {
        name: 'leadId',
        value: parseInt(e.target.value, 10),
      },
    });
  };

  const handleChangeOptionsFilter = useCallback((e) => {
    if (e.currentTarget.defaultValue === 'show-all') {
      setShowAssignmentFilter(false);
    } else {
      setShowAssignmentFilter(true);
    }
    handleChangeOptions(e);
  });

  useEffect(() => {
    const getComments = async () => {
      // Only fetch project leads for users with an organization
      // Client/vendor users don't have organizations and won't have project leads to filter by
      if (!userInfo?.organization) {
        return;
      }

      const items = await fetchProjectsLeads();
      setLeads(items.weddingsLeads);
    };
    getComments();
  }, [userInfo]);

  return (
    <>
      <ViewOptions afterDismiss={()=> afterDismissViewOptions()}>
        <div className="view-options__section">
          <ViewOptionsHeading>View As</ViewOptionsHeading>
          <OptionsItem
            label="Grid"
            name="view"
            id="grid"
            options={options}
            handleChange={handleChangeOptions}
          />
          <OptionsItem
            label="List"
            name="view"
            id="list-rb"
            options={options}
            handleChange={handleChangeOptions}
          />
        </div>
        <div className="view-options__section">
          <ViewOptionsHeading>Sort By</ViewOptionsHeading>
          {!viewingArchive && (
            <OptionsItem
              label="Date (chronological)"
              name="sort"
              id="date_asc"
              options={options}
              handleChange={handleChangeOptions}
            />
          )}
          {viewingArchive && (
            <>
              <OptionsItem
                label="Date (oldest to newest)"
                name="sortArchive"
                id="date_asc"
                options={options}
                handleChange={handleChangeOptions}
              />
              <OptionsItem
                label="Date (newest to oldest)"
                name="sortArchive"
                id="date_desc"
                options={options}
                handleChange={handleChangeOptions}
              />
            </>
          )}
          <OptionsItem
            label="Project Name"
            name={viewingArchive ? 'sortArchive' : 'sort'}
            id="project-name"
            options={options}
            handleChange={handleChangeOptions}
          />
        </div>
        {!viewingArchive && (
          <div className="view-options__section">
            <ViewOptionsHeading>Filter By</ViewOptionsHeading>
            <OptionsItem
              label="Show All"
              name="filter"
              id="show-all"
              options={options}
              handleChange={handleChangeOptionsFilter}
            />
            <OptionsItem
              label="Project Lead"
              name="filter"
              id="lead-name"
              options={options}
              handleChange={handleChangeOptionsFilter}
            />
            {showAssignmentFilter && (
              <ViewOptionsSelect
                inputProps={{
                  value: options.leadId,
                  onChange: setLead,
                }}
              >
                {weddingsLeads.map((row) => {
                  return (
                    <option value={row.loginId}
                      key={row.loginId}
                    >
                      {row.firstname} {row.lastname}
                    </option>
                  );
                })}
              </ViewOptionsSelect>
            )}
          </div>
        )}
        <div className="view-options__section">
          <ViewOptionsHeading>Visible Fields</ViewOptionsHeading>
          <VisibleItem
            name="service"
            label="Service"
            options={options}
            onChange={handleChangeCheckbox}
          />
          <VisibleItem
            name="location"
            label="Venue"
            options={options}
            onChange={handleChangeCheckbox}
          />
          <VisibleItem
            name="projectLead"
            label="Project Lead"
            options={options}
            onChange={handleChangeCheckbox}
          />
        </div>
      </ViewOptions>
    </>
  );
};

export default ProjectsViewOptions;
